<template>
<fragment>
<inboxemail :value="null" :selectable=true :showSubMenu=true  ></inboxemail>

</fragment>
  
</template>

<script>

export default {
  computed: {},
  components: {},
  data() {
    return {
      tags:[],
      query:"",
      state:""
    };
  },
  name: "InBox",
  beforeMount() {
  
   
  },

  mounted() {
 

    }
};
</script>
